import React from 'react';
import Router from './router';
import './app.css';

function App() {
  return (
    <div>
      <div className='main'>
        <Router />
      </div>
    </div>
  );
}

export default App;
